<template>
  <div class="main-body">
    <div class="main-header_bg"></div>
    <div class="main-header"></div>
    <div class="main-container">
      <iframe 
        class="main-iframe"
        style="width: calc(100vw - 30px); height: calc(100vh - 54px);  " 
        src="http://101.34.200.62/emonitor">
      </iframe>
    </div>
  </div>
</template>

<script>

// window.onmessage = ({data}) => {
//   const height = data.scrollHeight
//   if(height) {
//     document.getElementById('mainContainerIframe').style = `width: calc(100vw - 100px); height: ${height}px; `
//   }
// }

export default {
  name: 'App',
}
</script>

<style lang="less" scoped>
.main-body {
  background-color: rgba(27, 60, 140, 1);
  .main-header {
    height: 54px;
    background: #1B3c8c no-repeat;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1000;
  }
  .main-header_bg {
    height: 54px;
  }
  .main-container {
    padding: 0;
    margin: auto;
    min-height: calc(100vh - 54px);
    width: calc(100vw - 30px);
    border-radius: 15px 15px 0 0;
    overflow: hidden;
    .main-iframe {
      border-radius: 15px 15px 0 0;
      -ms-scroll-chaining: chained;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
